import styled from 'styled-components';

import { useSelector } from 'react-redux';
import { State } from '@store/index';
import { Result, ResultLoading } from './Result';
import { useState } from 'react';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  // total width - small sidenav far left - sidenav width - sidebar width - padding
  max-height: calc(100vh - 60px);
  width: calc(100vw - 61px - 240px - 400px - 50px);
  padding: 12px;
  border-radius: 6px;

  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    height: 12px;
    width: 12px;
  }

  &:not(:has(.Mui-expanded)) {
    & .MuiPaper-root {
      &:not(:last-of-type) {
        border-bottom: 0 !important;
      }
    }
  }
`;

const ResultContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const Results: React.FC = () => {
  const results = useSelector((state: State) => state.buckets.search.results);
  const isLoading = useSelector((state: State) => state.buckets.search.loading);
  const max_results = useSelector((state: State) => state.buckets.search.max_results);

  const [expanded, setExpanded] = useState<string | null>(null);

  return (
    <Container>
      {isLoading && (
        <ResultContainer>
          {Array.from({ length: max_results || 9 }, (_, index) => (
            <ResultLoading key={index} />
          ))}
        </ResultContainer>
      )}
      {!isLoading && (
        <ResultContainer>
          {results.map((result, index) => (
            <Result
              key={index}
              index={index}
              id={result.identifier}
              title={result.title}
              document={result.identifier.includes('.md') ? result?.body || '' : result.prompt}
              describe={result.describe}
              matched={result?.matched}
              filename={result.identifier}
              expanded={expanded}
              setExpanded={setExpanded}
            />
          ))}
        </ResultContainer>
      )}
    </Container>
  );
};
